import React, { useEffect, useState } from "react";
import AnimatedPage from "../animated/AnimatedPage";
import "./style/product.css";
import product from "../helper/Conrains";
import { useNavigate } from "react-router-dom";

function Product() {
  const [productState, setProductState] = useState();
  const navigate = useNavigate()
  useEffect(() => {
    setProductState([...product]);
  }, []);

  return (
    <AnimatedPage>
      <div className="container">
        {productState?.map((item) => {
          return (
            <div className="card" key={item.id} onClick={() => navigate("/product/detail", { replace: true,state:item })}>
              <h3 className="title">{item.name}</h3>
              <div className="bar">
                <div className="emptybar"></div>
                <div className="filledbar"></div>
              </div>
              <div className="circle">
                <img src={item.image1} alt="" width="200px" height="100px" />
              </div>
            </div>
          );
        })}
      </div>
    </AnimatedPage>
  );
}

export default Product;
